// don't arrange TagName in order because need to display tags in groups of 2 columns
export enum TagName {
  // only FE
  Paid = -2,
  MergedShipment = -1,
  //
  ManuallyCreated,
  SingleShipment = 3,
  FromComment = 1,
  MultiShipment = 4,
  FromCatalogue = 2,
  ActionRequired = 5,
  NewCart = 6,
  FromMessage = 7,
  PartiallyPaid,
  ToRefund,
  FromLivePin,
}

export const tagNameToDisplay = (tagName: TagName): string => {
  switch (tagName) {
    case TagName.ManuallyCreated:
      return 'manually_created';
    case TagName.FromComment:
      return 'from_comment';
    case TagName.FromCatalogue:
      return 'from_catalogue';
    case TagName.SingleShipment:
      return 'single_shipment';
    case TagName.MultiShipment:
      return 'multi_shipments';
    case TagName.ActionRequired:
      return 'action_required';
    case TagName.NewCart:
      return 'new_buyer';
    case TagName.FromMessage:
      return 'from_message';
    case TagName.MergedShipment:
      return 'merge_to_pack';
    case TagName.PartiallyPaid:
      return 'partially_paid';
    case TagName.ToRefund:
      return 'to_refund';
    case TagName.FromLivePin:
      return 'from_live_pin';
    default:
      return 'UNKNOWN TAG';
  }
};

export default TagName;
